import React from 'react';
import { CircleMarker } from 'react-leaflet';
import MarkerPopupComponent from './Marker-popup.component';
import { position } from '@store/Map.store';
import { IMarkerProps } from './IMarkerProps';

const Component: React.FC<IMarkerProps> = ({
    lang,
    gpsCoord,
    lbsCoord,
    imei,
    name,
    date,
    gpsDate,
    lbsDate,
    timezone,
    speed,
    dir,
    batteryVoltage,
    event,
    temperature,
    cur_sim,
    signal,
}: IMarkerProps) => {
    let position: position = [0, 0];
    if (gpsCoord && gpsCoord.lat && gpsCoord.lon) {
        position = [gpsCoord.lat, gpsCoord.lon];
    } else if (lbsCoord && lbsCoord.lat && lbsCoord.lon) {
        position = [lbsCoord.lat, lbsCoord.lon];
    }

    return (
        <CircleMarker center={position} radius={3} color="#2648ad">
            <MarkerPopupComponent
                lang={lang}
                gpsCoord={gpsCoord}
                lbsCoord={lbsCoord}
                imei={imei}
                name={name}
                date={date}
                gpsDate={gpsDate}
                lbsDate={lbsDate}
                timezone={timezone}
                speed={speed}
                dir={dir}
                batteryVoltage={batteryVoltage}
                event={event}
                temperature={temperature}
                cur_sim={cur_sim}
                signal={signal}
            />
        </CircleMarker>
    );
};

const DotMarkerComponent = React.memo(Component);

export default DotMarkerComponent;
